module.exports = __webpack_public_path__ + "img/realimg.cf8b83e0.svg";